import * as React from 'react';
const SvgArrow = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 12 10" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.033 1.934A.75.75 0 003.97.874L.373 4.471a.75.75 0 000 1.06l3.598 3.6A.75.75 0 005.033 8.07l-1.06-1.059a7.503 7.503 0 00-1.32-1.05l-.56-.352.036-.035.719.103c.351.05.706.075 1.06.075h7.342a.75.75 0 000-1.5H3.908a7.5 7.5 0 00-1.06.076l-.72.102-.035-.035.562-.352a7.5 7.5 0 001.317-1.05l1.06-1.059z"
            fill="currentColor"
        />
    </svg>
);
export default SvgArrow;
